<template>

</template>

<script>
export default {
  name: 'UpgradeAd'
}
</script>

<style scoped>

</style>
